export default __webpack_public_path__ + "static/media/general.9d7a3b80.jpg";